import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useFormik } from "formik";
import * as yup from "yup";
import axios from "axios";
import { toast } from "react-toastify";
import { AuthContext } from "../../auth/authContext";
import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";
import { createUser } from "../../API/ApiUsers";

import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import NativeSelect from "@mui/material/NativeSelect";
import { ReactReduxContext } from "react-redux";
import { getEstados, getMunicipios } from "../../API/ApiEstadosMunicipios";
import { DateTime } from "luxon";
import { createNewOrder } from "../../API/ApiOrdenesServicio";
import InputAdornment from "@mui/material/InputAdornment";
import { FactCheckIcon } from "@mui/icons-material/FactCheck";
import {
  agregarServicioAOrdenDeServicio,
  getServiciosOrdenesServicio,
} from "../../API/ApiServiciosOrdenesServicio";
import { nuevoPagoOrdenServicio } from "../../API/ApiPagosOrdenes";
import { agregarJardinAPanteon } from "../../API/ApiJardines";
import { AddPanteon } from "../../API/ApiPanteones";
import {
  AgregarUniplexByIdJardin,
  AsignarPersonaAUniplexByIdEspacio,
} from "../../API/ApiUniplex";
import { LoadingComponent } from "../LoadingComponent/LoadingComponent";
import {
  AgregarEspaciosACapillaByIdCapilla,
  AsignarPersonaAEspacioCapillaByIdEspacio,
} from "../../API/ApiCapillas";
import { AsignarPersonaADuplexByIdEspacio } from "../../API/ApiDuplex";

const validationSchema = yup.object({
  personaEspacio1: yup.string("Persona Espacio 1"),
  personaEspacio2: yup.string("Persona Espacio 2"),
  fechaIn1: yup.string("Fecha Espacio 1"),
  fechaIn2: yup.string("Fecha Espacio 2"),
  fechaEx1: yup.string("Fecha Espacio 1"),
  fechaEx2: yup.string("Fecha Espacio 2"),
});

export const AsignarFallecidosAEspacioDuplexComponent = (props) => {

  const { user, dispatch } = React.useContext(AuthContext);
  const [isDisabled, setIsDisabled] = React.useState(false);

  const escFunction = (event) => {
    if (event.keyCode === 27) {
      props.setCrudAction({ action: null, data: null });
    }
  };

  React.useEffect(() => {
    document.addEventListener("keydown", escFunction, false);
    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, []);

  const formik = useFormik({
    initialValues: {
      personaEspacio2:
        props.crudAction.data.personaEspacio2 == null
          ? ""
          : props.crudAction.data.personaEspacio2,
      personaEspacio1:
        props.crudAction.data.personaEspacio1 == null
          ? ""
          : props.crudAction.data.personaEspacio1,
      fechaIn1:
        props.crudAction.data.fechaIn1 == null
          ? "0000-00-00"
          : props.crudAction.data.fechaIn1,
      fechaIn2:
        props.crudAction.data.fechaIn2 == null
          ? "0000-00-00"
          : props.crudAction.data.fechaIn2,
      fechaEx1:
        props.crudAction.data.fechaEx1 == null
          ? "0000-00-00"
          : props.crudAction.data.fechaEx1,
      fechaEx2:
        props.crudAction.data.fechaEx2 == null
          ? "0000-00-00"
          : props.crudAction.data.fechaEx2,
      id: props.crudAction.data.id,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      setIsDisabled(true);
      AsignarPersonaADuplexByIdEspacio(user, values).then((resultado) => {
        if (resultado.status == 200) {
          props.setCrudAction({ action: null, data: null });
          toast.success("Nombre asignado Correctamente");
        } else {
          toast.error("Ha habido un error, consulte la consola");
        }
        setIsDisabled(false);
      });
    },
  });

  return (
    <>
      <div className="crudDivComponent col-md-3 px-4">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 my-2 mb-2">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6>Asignar fallecido a Espacio Duplex </h6>
                  <small className="text-muted">
                    Ingresa los datos para agregar Espacios
                  </small>
                </div>
                <div>
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() =>
                      props.setCrudAction({ action: null, data: null })
                    }
                  >
                    <CloseIcon fontSize="inherit" />{" "}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              {isDisabled == true ? (
                <>
                  <Alert className="mb-3" severity="info">
                    Procesando información...
                  </Alert>

                  <LoadingComponent />
                </>
              ) : null}
              <hr />
            </div>
          </div>
          <div className="row">
            <form onSubmit={formik.handleSubmit} className="container-fluid">
              <div className="row row-cols-1">
                <div className="col">
                  <TextField
                    size="small"
                    fullWidth
                    id="personaEspacio1"
                    name="personaEspacio1"
                    label="Persona Espacio 1"
                    type={"text"}
                    className="mb-3"
                    InputLabelProps={{ shrink: true }}
                    value={formik.values.personaEspacio1}
                    onChange={formik.handleChange}
                    variant="standard"
                    error={
                      formik.touched.personaEspacio1 &&
                      Boolean(formik.errors.personaEspacio1)
                    }
                    helperText={
                      formik.touched.personaEspacio1 &&
                      formik.errors.personaEspacio1
                    }
                    disabled={isDisabled}
                  />
                </div>

                <div className="col">
                  <TextField
                    size="small"
                    fullWidth
                    id="fechaIn1"
                    name="fechaIn1"
                    label="fechaIn1"
                    type={"date"}
                    className="mb-3"
                    InputLabelProps={{ shrink: true }}
                    value={formik.values.fechaIn1}
                    onChange={formik.handleChange}
                    variant="standard"
                    error={
                      formik.touched.fechaIn1 && Boolean(formik.errors.fechaIn1)
                    }
                    helperText={
                      formik.touched.fechaIn1 && formik.errors.fechaIn1
                    }
                    disabled={isDisabled}
                  />
                </div>
                <div className="col">
                  <TextField
                    size="small"
                    fullWidth
                    id="fechaEx1"
                    name="fechaEx1"
                    label="fechaEx1"
                    type={"date"}
                    className="mb-3"
                    InputLabelProps={{ shrink: true }}
                    value={formik.values.fechaEx1}
                    onChange={formik.handleChange}
                    variant="standard"
                    error={
                      formik.touched.fechaEx1 && Boolean(formik.errors.fechaEx1)
                    }
                    helperText={
                      formik.touched.fechaEx1 && formik.errors.fechaEx1
                    }
                    disabled={isDisabled}
                  />
                </div>

                <div className="col">
                  <TextField
                    size="small"
                    fullWidth
                    id="personaEspacio2"
                    name="personaEspacio2"
                    label="Persona Espacio 2"
                    type={"text"}
                    className="mb-3"
                    InputLabelProps={{ shrink: true }}
                    value={formik.values.personaEspacio2}
                    onChange={formik.handleChange}
                    variant="standard"
                    error={
                      formik.touched.personaEspacio2 &&
                      Boolean(formik.errors.personaEspacio2)
                    }
                    helperText={
                      formik.touched.personaEspacio2 &&
                      formik.errors.personaEspacio2
                    }
                    disabled={isDisabled}
                  />
                </div>

                <div className="col">
                  <TextField
                    size="small"
                    fullWidth
                    id="fechaIn2"
                    name="fechaIn2"
                    label="fechaIn2"
                    type={"date"}
                    className="mb-3"
                    InputLabelProps={{ shrink: true }}
                    value={formik.values.fechaIn2}
                    onChange={formik.handleChange}
                    variant="standard"
                    error={
                      formik.touched.fechaIn2 && Boolean(formik.errors.fechaIn2)
                    }
                    helperText={
                      formik.touched.fechaIn2 && formik.errors.fechaIn2
                    }
                    disabled={isDisabled}
                  />
                </div>
                <div className="col">
                  <TextField
                    size="small"
                    fullWidth
                    id="fechaEx2"
                    name="fechaEx2"
                    label="fechaEx2"
                    type={"date"}
                    className="mb-3"
                    InputLabelProps={{ shrink: true }}
                    value={formik.values.fechaEx2}
                    onChange={formik.handleChange}
                    variant="standard"
                    error={
                      formik.touched.fechaEx2 && Boolean(formik.errors.fechaEx2)
                    }
                    helperText={
                      formik.touched.fechaEx2 && formik.errors.fechaEx2
                    }
                    disabled={isDisabled}
                  />
                </div>

                <div className="col mt-3">
                  <button
                    type="submit"
                    className="btn btn-sm btn-success w-100"
                  >
                    Editar Fallecido
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
